export default __webpack_public_path__ + "static/media/login-bg-3.39f30807.png";